import React from "react";
import Typography from "@material-ui/core/Typography";
import intl from "react-intl-universal";
import { useField, Field } from "formik";

import { SelectField } from "components/SelectField";
import { ITeam } from "apis";
import { buildPlayerOption } from "utils";

import { EditorGrid } from "../EditorGrid";

import { FIELD } from "../../constants";
import { TEAM_TYPE } from "../../types";

interface IPlayerField {
  showBothPlayer?: boolean;
  homeTeam?: ITeam;
  awayTeam?: ITeam;
}

export const PlayerField = ({
  showBothPlayer,
  homeTeam,
  awayTeam,
}: IPlayerField) => {
  const [actionField] = useField(FIELD.action);
  const [teamTypeField] = useField(FIELD.teamType);

  return (
    <>
      <EditorGrid centerAlign item xs={2}>
        <Typography variant="h3">
          {intl.get("STAT_FORM_LABEL_PLAYER")}
        </Typography>
      </EditorGrid>
      <EditorGrid item xs={10}>
        <EditorGrid container>
          <EditorGrid item xs={5}>
            <Field
              component={SelectField}
              name={FIELD.fromPlayer}
              options={buildPlayerOption(
                intl.get("NONE_PLAYER_SELECTED"),
                teamTypeField.value === TEAM_TYPE.HOME ? homeTeam : awayTeam
              )}
            />
          </EditorGrid>
          {showBothPlayer && (
            <>
              <EditorGrid centerAlign item xs={2}>
                {actionField.value === "SHOOT"
                  ? intl.get("STATS_LABEL_ASSIST")
                  : `->`}
              </EditorGrid>
              <EditorGrid item xs={5}>
                <Field
                  component={SelectField}
                  name={FIELD.toPlayer}
                  options={buildPlayerOption(
                    intl.get("NONE_PLAYER_SELECTED"),
                    teamTypeField.value === TEAM_TYPE.HOME ? awayTeam : homeTeam
                  )}
                />
              </EditorGrid>
            </>
          )}
        </EditorGrid>
      </EditorGrid>
    </>
  );
};
